import { Container, Nav, Navbar } from "react-bootstrap";
import { User } from "../models/user";
import NavBarLoggedInView from "./NavBarLoggedInView";
import NavBarLoggedOutView from "./NavBarLoggedOutView";
import { Link } from "react-router-dom";
import '../styles/NavBar.css'; // Custom styles

interface NavBarProps {
    loggedInUser: User | null,
    onSignUpClicked: () => void,
    onLoginClicked: () => void,
    onLogoutSuccessful: () => void,
}

const NavBar = ({ loggedInUser, onSignUpClicked, onLoginClicked, onLogoutSuccessful }: NavBarProps) => {
    return (
        <Navbar expand="sm" sticky="top" className="modern-navbar">
            <Container>
                <Navbar.Brand style={{fontStyle:'italic'}} as={Link} to="/">
                    MAGELLAN MAPS
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-navbar" />
                <Navbar.Collapse id="main-navbar">
                    {loggedInUser && 
                        <Nav>
                            <Nav.Link style={{fontWeight:'normal'}} as={Link} to="/routes">
                                {'My Routes'}
                            </Nav.Link>
                        </Nav>
                    }


                    <Nav>
                        <Nav.Link style={{fontWeight:'normal'}} as={Link} to="/pricing">
                            {loggedInUser ? 'Manage My Plan':'Pricing'}
                        </Nav.Link>
                    </Nav>
                        <Nav>
                            <Nav.Link style={{fontWeight:'normal'}} as={Link} to="/contact">
                                {'Contact'}
                            </Nav.Link>
                        </Nav>
                    <Nav className="ms-auto">
                        {loggedInUser
                            ? <NavBarLoggedInView user={loggedInUser} onLogoutSuccessful={onLogoutSuccessful} />
                            : <NavBarLoggedOutView onLoginClicked={onLoginClicked} onSignUpClicked={onSignUpClicked} />
                        }
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBar;
